import { Observable } from "rxjs";

export class NgMockModelerService {

    constructor() { }

    getApiSpecs(): Observable<any> {
        return Observable.of([
            {
                "id": 1,
                "organizationID": "",
                "name": "TIBCO Cloud Integration PetStore Sample",
                "version": "1.1",
                "description": `To get you started with the API Modeling and Mock +
                                capabilities of TIBCO Cloud Integration we've created
                                a sample API Specification for you. This sample shows an +
                                API Specification for a PetStore API that can GET (retrieve), +
                                POST (create), PUT (create/update), PATCH (update) and +
                                DELETE pets in the store. To make things easier we've only created +
                                a small specification with a single resource '/pet/{petId}'`,
                "host": "",
                "basePath": "",
                "timeCreate": "2019-02-27T08:10:37Z",
                "timeUpdate": "2019-02-27T08:10:37Z",
                "timeDelete": "0001-01-01T00:00:00Z",
                "group": "Default"
            },
            {
                "id": 2,
                "organizationID": "",
                "name": "Swagger Sample",
                "version": "1.1",
                "description": `To get you started with the API Modeling and Mock`,
                "host": "",
                "basePath": "",
                "timeCreate": "2019-02-27T08:10:37Z",
                "timeUpdate": "2019-02-27T08:10:37Z",
                "timeDelete": "0001-01-01T00:00:00Z",
                "group": "Default"
            }
        ]);
    }
}
